function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M168 416c13 0 24-11 24-24V120c0-13-11-24-24-24-6 0-12 2-16 7L8 239c-5 4-8 10-8 17s3 13 8 17l144 136c4 5 10 7 16 7z"
});

function SvgCaretLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 512"
  }, props), _ref);
}

export default SvgCaretLeft;